import { getStoreSettings } from '@ttstr/api';
import { ThunkActionCreator } from '.';

export const SETTINGS_REQUESTED = 'STORESETTINGS.SETTINGS_REQUESTED';
export const SETTINGS_RECEIVED = 'STORESETTINGS.SETTINGS_RECEIVED';
export const SETTINGS_RECEIVE_FAILED = 'STORESETTINGS.SETTINGS_RECEIVED_FAILED';
export const SETTINGS_RECEIVE_DONE = 'STORESETTINGS.SETTINGS_RECEIVED_DONE';

export const receiveSettings: ThunkActionCreator = () => async (dispatch) => {
  dispatch({
    type: SETTINGS_REQUESTED,
  });

  try {
    const settings = await getStoreSettings();
    dispatch({
      type: SETTINGS_RECEIVED,
      payload: {
        settings: settings.store_config,
      },
    });
  } catch (error) {
    dispatch({
      type: SETTINGS_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
  } finally {
    dispatch({
      type: SETTINGS_RECEIVE_DONE,
    });
  }
};
